import { gql } from '../utils/general';

export const updateStoryThumbnail = gql`
  mutation UpdateStoryThumbnail($id: String!, $thumbnail: String!, $thumbnailRelativePath: String!) {
    update_stories_by_pk(
      pk_columns: { _id: $id }
      _set: { thumbnail: $thumbnail, thumbnailRelativePath: $thumbnailRelativePath }
    ) {
      _id
    }
  }
`;

export const updateTemplateThumbnail = gql`
  mutation UpdateTemplateThumbnail($id: String!, $thumbnail: String!, $thumbnailRelativePath: String!) {
    update_storyTemplates_by_pk(
      pk_columns: { _id: $id }
      _set: { thumbnail: $thumbnail, thumbnailRelativePath: $thumbnailRelativePath }
    ) {
      _id
    }
  }
`;

export const insertStory = gql`
  mutation InsertStory($entityId: Int!, $storyKey: String!, $title: String, $authorId: String!) {
    story: insert_stories_one(
      object: {
        entityId: $entityId
        storyKey: $storyKey
        title: $title
        authorId: $authorId
        createdBy: $authorId
        updatedBy: $authorId
      }
    ) {
      _id
      authorId
      description
      createdAt
      createdBy
      entityId
      state
      storyKey
      title
      updatedAt
      updatedBy
      visibility
      embeds {
        embedId
      }
    }
  }
`;

export const removeStory = gql`
  mutation RemoveStory($id: String!) {
    story: delete_stories(where: { _id: { _eq: $id }, state: { _eq: draft } }) {
      affected_rows
    }
  }
`;

export const insertPortalStory = gql`
  mutation InsertPortalStory($portalStory: portalStory_insert_input!) {
    insert_portalStory_one(object: $portalStory) {
      _id
    }
  }
`;

export const updatePortalStory = gql`
  mutation UpdatePortalStory($id: String!, $order: Int!) {
    update_portalStory_by_pk(_set: { order: $order }, pk_columns: { _id: $id }) {
      _id
    }
  }
`;

export const removePortalStory = gql`
  mutation DeletePortalStory($id: String!) {
    delete_portalStory_by_pk(_id: $id) {
      _id
    }
  }
`;

export const removeInternalPublishedStory = gql`
  mutation removeInternalPublishedStory($id: String!) {
    delete_internalPublishedStory(where: { storyId: { _eq: $id } }) {
      affected_rows
    }
  }
`;

export const createStoryFolder = gql`
  mutation createStoryFolder($storyFolder: storyFolders_insert_input!) {
    insert_storyFolders_one(object: $storyFolder) {
      id
      entityId
      title
      parentFolderId
      publicationId
    }
  }
`;

export const insertPublicationFolder = gql`
  mutation insertPublicationFolder($publicationFolder: publicationFolders_insert_input!) {
    insert_publicationFolders_one(object: $publicationFolder) {
      createdAt
      createdBy
      folderId
      publicationId
      updatedAt
    }
  }
`;

export const updateStoryFolders = gql`
  mutation updateStoryFolder($publicationId: uuid!, $folderIds: [uuid!], $parentFolderId: uuid!) {
    update_storyFolders(
      where: { id: { _in: $folderIds } }
      _set: { publicationId: $publicationId, parentFolderId: $parentFolderId }
    ) {
      affected_rows
    }
  }
`;

export const updatePublicationInSubFolders = gql`
  mutation updateStorySubFolder($publicationId: uuid!, $folderIds: [uuid!]) {
    update_storyFolders(where: { id: { _in: $folderIds } }, _set: { publicationId: $publicationId }) {
      affected_rows
    }
  }
`;

export const renameFolder = gql`
  mutation renameFolder($folderId: uuid!, $folderName: String!) {
    update_storyFolders(where: { id: { _eq: $folderId } }, _set: { title: $folderName }) {
      affected_rows
    }
  }
`;

export const removeFolder = gql`
  mutation removeFolder($id: uuid!) {
    delete_storyFolders(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;

export const createPublication = gql`
  mutation createPublication($publication: publications_insert_input!) {
    insert_publications_one(object: $publication) {
      createdAt
      createdBy
      description
      entityId
      id
      publicUrl
      publishedAt
      publishedBy
      status
      thumbnailPath
      title
      updatedAt
      updatedBy
      orgId
      createdByUser {
        _id
        email
        firstName
        lastName
        opengovId
        title
      }
    }
  }
`;

export const createPublicationBrandings = gql`
  mutation createPublicationBrandings($publicationBrandings: publicationBrandings_insert_input!) {
    insert_publicationBrandings_one(object: $publicationBrandings) {
      id
      idleBackgroundColor
      activeBackgroundColor
      activeFontColor
      createdAt
      enableLogoNavigation
      fontStyle
      idleFontColor
      isNavigationMenuSticky
      logoUrl
      publicationId
      showLogoOnFooter
      updatedAt
      enableGoogleTranslate
    }
  }
`;

export const createPublicationTOCSettings = gql`
  mutation createPublicationTOCSettings($publicationTOCSettings: publicationTOCSettings_insert_input!) {
    insert_publicationTOCSettings_one(object: $publicationTOCSettings) {
      id
      columnLayoutNumber
      createdAt
      createdBy
      headerHeightSize
      headerImageUrl
      menuTitle
      pageTitle
      publicationId
      showTableOfContents
      updatedAt
    }
  }
`;

export const createPublicationFooterSettings = gql`
  mutation createPublicationFooterSettings($publicationFooterSettings: publicationFooterSettings_insert_input!) {
    insert_publicationFooterSettings_one(object: $publicationFooterSettings) {
      id
      publicationId
      backgroundColors
      fontColors
      mediaLinks
      createdAt
      updatedAt
      createdBy
    }
  }
`;

export const updatePublicationThumbnail = gql`
  mutation updatePublicationThumbnail($publicationId: uuid!, $entityId: Int!, $thumbnailPath: String) {
    update_publications(
      where: { id: { _eq: $publicationId }, entityId: { _eq: $entityId } }
      _set: { thumbnailPath: $thumbnailPath }
    ) {
      affected_rows
    }
  }
`;

export const insertStoriesForMenuId = gql`
  mutation insertStoriesForMenuId($objects: [publicationNavigationMenuStories_insert_input!]!) {
    storiesList: insert_publicationNavigationMenuStories(objects: $objects) {
      affected_rows
      returning {
        id
      }
    }
  }
`;

export const updateStory = gql`
  mutation updateStory($id: String!, $data: stories_set_input!) {
    resource: update_stories_by_pk(pk_columns: { _id: $id }, _set: $data) {
      _id
      author {
        _id
        email
        firstName
        lastName
        opengovId
      }
      createdAt
      createdBy
      description
      entityId
      paddingBottom
      paddingTop
      publicUrl
      publishedAt
      authorId
      publishedBy
      state
      storyKey
      thumbnail
      thumbnailRelativePath
      title
      updatedAt
      updatedBy
      visibility
    }
  }
`;

export const upsertInternalStory = gql`
  mutation upsertInternalStories($internalStory: internalPublishedStory_insert_input!) {
    insert_internalPublishedStory_one(
      object: $internalStory
      on_conflict: { constraint: internalPublishedStory_storyId_key, update_columns: [contentHtml] }
    ) {
      _id
    }
  }
`;

export const addProposalToStory = gql`
  mutation addProposalToStory($objects: storyBudgetProposals_insert_input!) {
    insert_storyBudgetProposals_one(object: $objects) {
      id
    }
  }
`;

export const removeBudgetAndProposalsInStory = gql`
  mutation removeBudgetAndProposalsInStory($proposalId: Int, $storyId: String!) {
    delete_storyBudgetProposals(where: { storyId: { _eq: $storyId }, proposalId: { _eq: $proposalId } }) {
      affected_rows
    }
  }
`;

export const removeAllBudgetProposalsInStory = gql`
  mutation removeAllBudgetProposalsInStory($storyId: String!) {
    delete_storyBudgetProposals(where: { storyId: { _eq: $storyId } }) {
      affected_rows
    }
  }
`;

export const deleteFoldersCopyAndExportInfo = gql`
  mutation deleteFoldersCopyAndExportInfo($folderIds: [uuid!]) {
    delete_storyFoldersCopyProcesses(where: { destinationFolderId: { _in: $folderIds } }) {
      affected_rows
    }
    delete_storiesCopyProcesses(where: { destinationFolderId: { _in: $folderIds } }) {
      affected_rows
    }
    delete_exportFolderPdfRequests(where: { folderId: { _in: $folderIds } }) {
      affected_rows
    }
  }
`;

export const replaceProposalInStory = gql`
  mutation replaceProposalInStory($proposalId: Int, $id: uuid!) {
    proposal: update_storyBudgetProposals_by_pk(pk_columns: { id: $id }, _set: { proposalId: $proposalId }) {
      id
    }
  }
`;

export const removeStoryContentsByIds = gql`
  mutation removeContentByIds($contentIds: [String!]) {
    delete_storyContents(where: { _id: { _in: $contentIds } }) {
      affected_rows
    }
  }
`;

export const updateStoriesUpdatedAt = gql`
  mutation updateUpdatedAtOfStories($storyIds: [String!], $updatedAt: timestamp, $userId: String!) {
    update_stories(where: { _id: { _in: $storyIds }}, _set: { updatedAt: $updatedAt, updatedBy: $userId }) {
      affected_rows
    }
  }
`;

export const upsertStoryProgressTrackerConfig = gql`
  mutation upsertStoryProgressTrackerConfig($payload: [chartsConfig_insert_input!] = {}) {
    insert_chartsConfig(objects: $payload, on_conflict: {constraint: chartsConfig_pkey, update_columns: config}) {
    affected_rows
    returning {
      config
      contentId
      createdAt
      entityId
      id
      storyId
      type
      updatedAt
    }
  }
}
`;
